export const convertMinToDayHourMin = (value: number | null, type: string) => {
    const MinsPerDay = type === 'W' ? 540 : 1440;
    let MinsLeft = value ?? 0;
    const Days = Math.floor(MinsLeft / MinsPerDay);
    MinsLeft = MinsLeft - Days * MinsPerDay;
    const Hours = Math.floor(MinsLeft / 60);
    MinsLeft = Math.round(MinsLeft - Hours * 60);
    return `${Days}d ${Hours}h ${MinsLeft}m`;
  };
  